/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Showcase_Value_HintInputs */



/**
* | output |
* | --- |
* | "For a typical request at our prices, compared with the cheapest model that scores at least as high in the Artificial Analysis Intelligence Index and is hoste..." |
*
* @param {Model_Showcase_Value_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_showcase_value_hint = /** @type {((inputs?: Model_Showcase_Value_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Showcase_Value_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Für eine typische Anfrage zu unseren Preisen, verglichen mit dem günstigsten Modell, das im Artificial Analysis Intelligence Index mindestens gleich gut abschneidet und mindestens so streng gehostet wird")
	return /** @type {LocalizedString} */ ("For a typical request at our prices, compared with the cheapest model that scores at least as high in the Artificial Analysis Intelligence Index and is hosted at least as strictly")
});